import PageHeader from "@/components/PageHeader";
import { SHORTS, BRAND } from "@/data/content";
import { Youtube, ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const CHANNEL_URL = BRAND.socials.youtube;
const SHORTS_URL = `${CHANNEL_URL}/shorts`;

export default function Shorts() {
    return (
        <>
            <PageHeader
                eyebrow="YouTube Shorts"
                title="60-second breakdowns."
                subtitle={`Quick product reviews, buying tips and honest takes — on our channel ${BRAND.youtubeHandle}. Placeholder embeds below will be swapped for real videos once individual video IDs are added.`}
            />

            {/* Channel spotlight CTA */}
            <section className="container-editorial pb-10">
                <div data-testid="shorts-channel-cta" className="bg-primary text-primary-foreground rounded-2xl p-8 md:p-12 grid md:grid-cols-12 gap-6 items-center grain relative overflow-hidden">
                    <div className="md:col-span-8">
                        <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 rounded-full px-3 py-1 text-xs">
                            <Youtube className="h-3.5 w-3.5 text-accent" />
                            <span>{BRAND.youtubeHandle}</span>
                        </div>
                        <h2 className="font-serif text-3xl md:text-4xl leading-tight mt-4">
                            Subscribe to <span className="italic">{BRAND.youtubeHandle}</span> on YouTube.
                        </h2>
                        <p className="text-stone-200 mt-3 max-w-xl">
                            New Shorts on product reviews, buying tips, AI tools, shopping hacks and quick honest takes — every week.
                        </p>
                    </div>
                    <div className="md:col-span-4 flex flex-col gap-3 md:items-end">
                        <Button asChild data-testid="shorts-subscribe-btn" className="rounded-full bg-accent hover:bg-accent/90 text-accent-foreground h-12 px-7 w-full md:w-auto">
                            <a href={CHANNEL_URL} target="_blank" rel="noopener noreferrer">
                                <Youtube className="h-4 w-4 mr-2" /> Visit channel
                            </a>
                        </Button>
                        <Button asChild variant="outline" data-testid="shorts-view-all-btn" className="rounded-full h-12 px-7 bg-transparent text-primary-foreground border-primary-foreground/30 hover:bg-white/10 w-full md:w-auto">
                            <a href={SHORTS_URL} target="_blank" rel="noopener noreferrer">
                                See all Shorts <ArrowUpRight className="h-4 w-4 ml-1" />
                            </a>
                        </Button>
                    </div>
                </div>
            </section>

            <section className="container-editorial pb-24">
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
                    {SHORTS.map((s) => (
                        <div key={s.id} data-testid={`shorts-item-${s.id}`} className="card-editorial rounded-lg overflow-hidden flex flex-col">
                            <div className="aspect-[9/16] bg-stone-900 relative">
                                <iframe
                                    className="absolute inset-0 w-full h-full"
                                    src={`https://www.youtube.com/embed/${s.id}`}
                                    title={s.title}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    loading="lazy"
                                />
                            </div>
                            <div className="p-4">
                                <p className="text-sm leading-snug font-medium line-clamp-2">{s.title}</p>
                                <p className="text-xs text-stone-500 mt-1 flex items-center gap-1">
                                    <Youtube className="h-3 w-3" /> Placeholder — swap with {BRAND.youtubeHandle} video IDs
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </>
    );
}
